module.exports = __webpack_public_path__ + "static/media/dollar.a0cf719a.svg";